var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 34",
    style: {
      enableBackground: "new 0 0 32 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F7931A;}\r\n\t.st1{fill:#CE7819;}\r\n\t.st2{fill:#CC7619;}\r\n\t.st3{fill:#F7931A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,17c0,8.6-6.8,15.6-15.1,15.6S0.9,25.6,0.9,17S7.7,1.4,16,1.4S31.1,8.4,31.1,17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,24.4c-0.5,0-0.4-0.2-0.6-0.7l-1.5-5l11.4-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.1,24.4c0.4,0,0.6-0.2,0.8-0.4l2.1-2.1l-2.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4,20.3l6.3,4.8c0.7,0.4,1.2,0.2,1.4-0.7l2.6-12.4c0.3-1.1-0.4-1.6-1.1-1.3l-15,6c-1,0.4-1,1-0.2,1.3 l3.9,1.2l8.9-5.8c0.4-0.3,0.8-0.1,0.5,0.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.010c219b4c31758278630dde5c4eca50.svg";
export { ForwardRef as ReactComponent };